import React from 'react';
import { PhoneIcon, MessageCircleIcon } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-12 md:py-20 px-4 md:px-6 lg:px-16 bg-gradient-to-br from-[#121c53] to-[#1a2a70]" data-id="element-46">
      <div className="max-w-4xl mx-auto text-center" data-id="element-47">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6 px-4" data-id="element-48">
          Contactează Echipa Noastră
        </h2>
        <p className="text-gray-300 text-base md:text-lg mb-8 md:mb-12 px-4" data-id="element-49">
          Pentru detalii, documentație completă sau programare vizionare,
          contactează direct echipa noastră.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-8" data-id="element-50">
          {/* Contact Card 1 - Ștefan Bira */}
          <div className="bg-gradient-to-br from-white to-gray-50 p-6 md:p-8 rounded-2xl shadow-xl" data-id="element-51">
            {/* Profile Photo */}
            <div className="flex justify-center mb-4 md:mb-6" data-id="element-52">
              <div className="w-24 h-24 md:w-28 md:h-28 rounded-full border-4 border-[#357beb] shadow-lg overflow-hidden bg-gray-200" data-id="element-53">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ePG7pXuRdXpoxVhdG1phNA/1_de_folosit.jpg" alt="Ștefan Bira" className="w-full h-full object-cover" data-id="element-54" />
              </div>
            </div>
            {/* Name and Title */}
            <h3 className="text-xl md:text-2xl font-bold text-[#121c53] mb-1 md:mb-2" data-id="element-55">
              Ștefan Bira
            </h3>
            <p className="text-gray-600 font-medium mb-6 md:mb-8" data-id="element-56">
              Director Vânzări
            </p>
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-57">
              <a href="tel:+40760243210" className="flex-1 flex items-center justify-center gap-2 px-4 py-3 md:py-4 bg-[#357beb] hover:bg-[#357beb]/90 text-white font-semibold rounded-lg transition-all duration-300 shadow-md hover:shadow-lg touch-manipulation" data-id="element-58">
                <PhoneIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-59" />
                <span className="text-xs md:text-sm" data-id="element-60">Call: 0760.243.210</span>
              </a>
              <a href="https://wa.me/40760243210" target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 px-4 py-3 md:py-4 bg-[#25D366] hover:bg-[#25D366]/90 text-white font-semibold rounded-lg transition-all duration-300 shadow-md hover:shadow-lg touch-manipulation" data-id="element-61">
                <MessageCircleIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-62" />
                <span className="text-xs md:text-sm" data-id="element-63">WhatsApp</span>
              </a>
            </div>
          </div>
          {/* Contact Card 2 - Simona Stancu */}
          <div className="bg-gradient-to-br from-white to-gray-50 p-6 md:p-8 rounded-2xl shadow-xl" data-id="element-64">
            {/* Profile Photo */}
            <div className="flex justify-center mb-4 md:mb-6" data-id="element-65">
              <div className="w-24 h-24 md:w-28 md:h-28 rounded-full border-4 border-[#357beb] shadow-lg overflow-hidden bg-gray-200" data-id="element-66">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2RJsJMvgATx9WHeZt88dFe/image.png" alt="Simona Stancu" className="w-full h-full object-cover object-top" data-id="element-67" />
              </div>
            </div>
            {/* Name and Title */}
            <h3 className="text-xl md:text-2xl font-bold text-[#121c53] mb-1 md:mb-2" data-id="element-68">
              Simona Stancu
            </h3>
            <p className="text-gray-600 font-medium mb-6 md:mb-8" data-id="element-69">
              Office Manager
            </p>
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-70">
              <a href="tel:+40722225574" className="flex-1 flex items-center justify-center gap-2 px-4 py-3 md:py-4 bg-[#357beb] hover:bg-[#357beb]/90 text-white font-semibold rounded-lg transition-all duration-300 shadow-md hover:shadow-lg touch-manipulation" data-id="element-71">
                <PhoneIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-72" />
                <span className="text-xs md:text-sm" data-id="element-73">Call: 0722.225.574</span>
              </a>
              <a href="https://wa.me/40722225574" target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 px-4 py-3 md:py-4 bg-[#25D366] hover:bg-[#25D366]/90 text-white font-semibold rounded-lg transition-all duration-300 shadow-md hover:shadow-lg touch-manipulation" data-id="element-74">
                <MessageCircleIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-75" />
                <span className="text-xs md:text-sm" data-id="element-76">WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}